import * as Sentry from '@sentry/react';
import { getReleaseVersion, getProjectName } from './release';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://02289a925662789c87804d6d7ff47a37@o4508660463370240.ingest.us.sentry.io/4509674415194112',
    sendDefaultPii: true,
    release: `${getProjectName()}@${getReleaseVersion()}`,
    integrations: [],
    ignoreErrors: [],
  });
}
